

function HomeIcon(props) {
  return (
    <svg className={props.className} width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M28.5 31.4999H7.5C7.10218 31.4999 6.72064 31.3418 6.43934 31.0605C6.15804 30.7792 6 30.3977 6 29.9999V16.4999H1.5L16.9905 2.41788C17.2667 2.1666 17.6266 2.02734 18 2.02734C18.3734 2.02734 18.7333 2.1666 19.0095 2.41788L34.5 16.4999H30V29.9999C30 30.3977 29.842 30.7792 29.5607 31.0605C29.2794 31.3418 28.8978 31.4999 28.5 31.4999ZM19.5 28.4999H27V13.7354L18 5.55438L9 13.7354V28.4999H16.5V19.4999H19.5V28.4999Z" fill={props.fill}/>
</svg>
  )
}

export default HomeIcon